import { Component, input } from '@angular/core';

import { KeyValueDisplay } from './key-value.model';

/**
 * @ngdoc component
 * @name ApKeyValueComponent
 * @deprecated In favor of plain CSS `dl.ap-definition-list>dt+dd`
 */
@Component({
    selector: 'dl',
    templateUrl: './key-value.component.html',
    styleUrls: ['./key-value.component.scss'],
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': '"keys-values display-" + display()',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class.key-value-align-right]': 'alignRight()'
    }
})
export class ApKeyValueComponent {
    /**
     * How should the key / value be displayed.
     * Possible options `KeyValueDisplay`
     * defaults to `KeyValueDisplay.mixed`
     */
    public readonly display = input<string>(KeyValueDisplay.mixed);

    /**
     * Should the values be aligned right?
     * Defaults to false
     */
    public readonly alignRight = input(false);
}
